import React from "react";

import { Row, Col } from "react-bootstrap";
import { ErrorBoundary } from "react-error-boundary";
// import * as Sentry from "@sentry/react";

const clearCacheData = () => {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });
};

const WAIT_BEFORE_RELOAD = 10;

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const homeURL = "https://www.divorcepath.com";
  const [timeLeft, setTimeLeft] = React.useState(WAIT_BEFORE_RELOAD);

  React.useEffect(() => {
    if (process.env.REACT_APP_ENV_NAME === "production") {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            resetErrorBoundary();
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [resetErrorBoundary]);

  return (
    <div
      role="alert"
      className="d-flex flex-column justify-content-center align-items-center w-100 h-100"
    >
      <div className="logo-column mb-4">
        <a href={homeURL}>
          <img
            alt="Divorcepath.com"
            src="./img/brand/divorcepath-black.svg"
            style={{ width: 300, height: 64 }}
          />
        </a>
      </div>
      <Row className="justify-content-center px-3 py-2 text-center">
        <Col xs={12} md={8} lg={6}>
          <div className="alert alert-warning">
            <h4 className="alert-heading">We encountered an error</h4>
            <p>
              Apologies for the inconvenience. Our application encountered a glitch. Please take a
              screenshot and contact support.
              {process.env.REACT_APP_ENV_NAME === "production" && (
                <React.Fragment>
                  {" "}
                  We'll reload in <strong>{timeLeft}</strong> seconds to fix it.
                </React.Fragment>
              )}
              {process.env.REACT_APP_ENV_NAME !== "production" && (
                <React.Fragment> Click the button below to reload the application.</React.Fragment>
              )}
            </p>
            {process.env.REACT_APP_ENV_NAME !== "production" && (
              <button type="button" className="btn btn-primary mt-2" onClick={resetErrorBoundary}>
                Reload Application
              </button>
            )}
          </div>
        </Col>
      </Row>
      <div className="mt-3 p-3 bg-dark text-white rounded">
        <strong>Error details:</strong>
        <pre className="mt-2 mb-0">{error.message}</pre>
        {error.stack && (
          <pre className="mt-2 mb-0 text-danger">
            {error.stack.split("\n").slice(0, 3).join("\n")}
          </pre>
        )}
      </div>
    </div>
  );
};

const MainErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => {
        console.error("Error caught by boundary:", { error, info });
        // TODO:
        // try {
        //   Sentry.captureException(error, {
        //     extra: {
        //       componentStack: info.componentStack,
        //     },
        //   });
        // } catch (sentryError) {
        //   console.error("Failed to report to Sentry:", sentryError);
        // }
      }}
      onReset={() => {
        clearCacheData();
        window.location.replace("/app");
        window.location.reload(true);
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default MainErrorBoundary;
